
/**
 * 红包定义
 */
export interface HongDefine {
    uniqueId : string;
    name : string;//显示名称
    prize : number;//类型
    appearWeight : number;//出现几率
    weight : number;//权重 放大100倍
}
/**
 * 红包定义
 * @constructor
 */
export function HongPrize() : HongDefine[]{
    const dataList : HongDefine[] = [
        // {
        //     uniqueId : "1",
        //     name : "5元",
        //     prize : 5,
        //     appearWeight : 4030,
        //     weight:7900,
        // },
        // {
        //     uniqueId : "2",
        //     name : "10元",
        //     prize : 10,
        //     appearWeight : 2500,
        //     weight : 1100,
        // },
        // {
        //     uniqueId : "3",
        //     name : "20元",
        //     prize : 20,
        //     appearWeight : 700,
        //     weight : 1500,
        // },
        // {
        //     uniqueId : "4",
        //     name : "100元",
        //     prize : 100,
        //     appearWeight : 200,
        //     weight : 750,
        // },
        // {
        //     uniqueId : "5",
        //     name : "1000元",
        //     prize : 1000,
        //     appearWeight : 70,
        //     weight : 350,
        // },
        // {
        //     uniqueId : "6",
        //     name : "一万",
        //     prize : 10000,
        //     appearWeight : 500,
        //     weight : 20,
        // },
        // {
        //     uniqueId : "7",
        //     name : "五万",
        //     prize : 50000,
        //     appearWeight : 500,
        //     weight : 7,
        // },
        // {
        //     uniqueId : "8",
        //     name : "十万",
        //     prize : 100000,
        //     appearWeight : 1000,
        //     weight : 2,
        // },
        // {
        //     uniqueId : "9",
        //     name : "一百万",
        //     prize : 1000000,
        //     appearWeight : 1000,
        //     weight : 1,
        // },
    ];
    return dataList;
}

/**
 * 获取随机
 */
export function getRandomHongPrize() : HongDefine{
    let retData : HongDefine = null;
    const dataList = HongPrize();
    let randomNum = Math.floor( Math.random() * 10000 );
    for ( let item of dataList ) {
        if ( randomNum <= item.appearWeight ) {
            retData = item;
            break;
        }
        randomNum -= item.appearWeight;
    }
    return retData;
}
